<template>
  <div class="login_bg" style="height:100%">
    <img src="../../assets/images/about-bg.png" alt="" class="top-img">

    <div class="company-int">
      <div>杭州闪派网络科技有限公司</div>
      <div>杭州闪派网络科技有限公司成立于2016年，坐落于美丽的西子湖畔杭州，
        是国内领先的食品饮料企业数智化解决方案及智慧运营的科技服务公司。曾获知名机构千万级融资。为食品饮料、连锁便利，区域经销企业提供业务咨询服务及核心业务软件服务，使用客户遍布全国及香港、台湾等地区。服务仓库800+，使用人员25000+，日均活跃人数8000+，累计合计处理业务订单数5000万+。
      </div>
    </div>

    <!-- 企业荣誉 -->
    <div class="wrap-box" style="background-color: #F8FBFE;">
      <div class="title-s">企业荣誉</div>
      <div class="content-box ry-cont-box">
        <div class="each-ry">
          <img src="../../assets/images/rongyu-01.png" alt="" class="img-1">
          <div>ISO9001认证</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-02.png" alt="" class="img-1">
          <div>ISO27001认证</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-03.png" alt="" class="img-1">
          <div>45项软件著作权</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-04.png" alt="" class="img-1">
          <div>百度地图商业授权</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-05.png" alt="" class="img-2">
          <div>国家高新技术企业</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-06.png" alt="" class="img-2">
          <div>杭州市高新技术企业</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-07.png" alt="" class="img-2">
          <div>软件成熟度3级</div>
        </div>

        <div class="each-ry">
          <img src="../../assets/images/rongyu-08.png" alt="" class="img-2">
          <div>太古饮料供应链BP&CI评选金奖</div>
        </div>
      </div>
    </div>

    <!-- 企业发展历程 -->
    <div class="wrap-box">
      <div class="title-s">企业发展历程</div>

      <div class="content-box">
        <el-carousel indicator-position="none" height="460px" @change="changeImg" ref="carousel">
          <el-carousel-item v-for="item in year_img" :key="item" autoplay="false">
            <img :src="item" alt="" style="width: 100%;">
          </el-carousel-item>
        </el-carousel>

        <div class="timeline-box">
          <div class="bg-line"></div>
          <div class="year-box">
            <div class="each-year" v-for="(item, index) in year_arr" :key="index">
              <div class="dian-box" :style="pitch_on == index ? 'background-color: #0277F9' : ''">
                <div class="unchecked" :style="pitch_on == index ? 'background-color: #FFFFFF' : ''" @click="pitchOn(index)">
                </div>
              </div>
              <div :style="pitch_on == index ? 'color: #0277F9;font-size: 20px;' : ''">{{ item }}</div>
            </div>
          </div>

          <div class="triangle"></div>
        </div>
      </div>

    </div>

    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'

export default {
  name: "AboutUs",
  data() {
    return {
      year_arr: [2017, 2018, 2019, 2020, 2021, 2022, 2023],
      pitch_on: 0,
      year_img:[require('@/assets/images/2017.jpg'),require('@/assets/images/2018.jpg'),require('@/assets/images/2019.jpg'),require('@/assets/images/2020.jpg'),require('@/assets/images/2021.jpg'),require('@/assets/images/2022.jpg'),require('@/assets/images/2023.jpg')],
    }
  },
  created() {

  },
  mounted() { },
  methods: {
    pitchOn(index) {
      this.pitch_on = index
      this.$refs.carousel.setActiveItem(index)
    },
    changeImg(e){
      console.log(e)
      this.pitch_on = e
    },
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath
    }),
  },
}
</script>
<style scoped lang="scss">
.el-container {
  flex-direction: column;
  position: relative;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #B6B6B6;
    padding: 20px 0;
    a{
      color: #B6B6B6;
    }
    // position: absolute;
    // left: calc(50% - 437px);
    // bottom: 0;
  }
}

.top-img {
  width: 100%;
}

.company-int {
  position: relative;
  width: 1560px;
  height: 249px;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px rgba(147, 147, 147, 0.2);
  border-radius: 4px;
  margin: -60px auto 0 auto;
  z-index: 10;

  >div:nth-child(1) {
    text-align: center;
    font-size: 24px;
    color: #202741;
    padding: 40px 0;
  }

  >div:nth-child(2) {
    width: 1427px;
    font-size: 20px;
    margin: 0 auto;
    color: #626262;
  }
}

.wrap-box {
  padding-bottom: 20px;

  .title-s {
    font-size: 32px;
    text-align: center;
    margin: 60px 0 40px 0;
  }

  .content-box {
    width: 1560px;
    margin: 0 auto;
  }

  .ry-cont-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .each-ry {
      width: 366px;
      height: 288px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-bottom: 20px;
      box-sizing: border-box;
      padding-top: 10px;

      img {
        display: block;
        margin: 0 auto;
      }

      .img-1 {
        width: 136px;
        height: 200px;
      }

      .img-2 {
        width: 302px;
        height: 214px;
      }

      >div {
        margin-top: 10px;
        text-align: center;
        font-size: 24px;
      }
    }
  }
}

.timeline-box {
  position: relative;
  margin-top: 50px;
  .bg-line {
    width: 100%;
    height: 6px;
    background-color: #C2D6EB;
  }

  .triangle {
    width: 0;
    height: 0;
    border-left: 30px solid #0277F9;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    position: absolute;
    top: -13px;
    right: -23px;
  }

  .year-box {
    display: flex;
    justify-content: space-around;
    margin-top: -18px;

    .each-year {
      text-align: center;
      font-size: 16px;

      .dian-box {
        width: 30px;
        height: 30px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        justify-content: center;
        // background-color: red;
        border-radius: 50%;
        margin: 0 auto;
      }

      .unchecked {
        width: 20px;
        height: 20px;
        background: #669FDE;
        border-radius: 50%;
        margin: 0 auto;
      }
    }

  }
}</style>